import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const opportunities = [
  {
    icon: 'ri-calendar-event-line',
    title: 'Event Support',
    commitment: '4-8 hours/month',
  },
  {
    icon: 'ri-presentation-line',
    title: 'Health Education',
    commitment: '6-10 hours/month',
  },
  {
    icon: 'ri-community-line',
    title: 'Community Outreach',
    commitment: 'Flexible schedule',
  },
];

export default function GetInvolved() {
  return (
    <section className="relative py-20 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/b0d13e71251f6389fc70a2279c7881a5.jpg"
          alt="Volunteers in Action"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-purple/90 via-purple/70 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="inline-block bg-white/20 text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
              Make a Difference
            </span>
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-white mb-8 leading-tight">
              Join Our
              <br />
              Volunteer Family
            </h2>

            {/* Volunteer Roles */}
            <div className="space-y-4 mb-8">
              {opportunities.map((opp, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="flex items-center space-x-4 bg-white/10 backdrop-blur-sm rounded-xl p-4"
                >
                  <div className="w-16 h-16 flex items-center justify-center bg-coral rounded-xl flex-shrink-0">
                    <i className={`${opp.icon} text-3xl text-white`}></i>
                  </div>
                  <div>
                    <div className="text-white font-semibold text-lg">{opp.title}</div>
                    <div className="text-white/80 text-sm">{opp.commitment}</div>
                  </div>
                </motion.div>
              ))}
            </div>

            <Link
              to="/get-involved"
              className="inline-block bg-coral text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-coral/90 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              Apply to Volunteer
            </Link>
          </motion.div>

          {/* Right Testimonial */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="hidden lg:block"
          >
            <div className="bg-white rounded-2xl p-8 shadow-2xl">
              <div className="flex items-center space-x-4 mb-6">
                <div className="w-20 h-20 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src="https://readdy.ai/api/search-image?query=portrait%20of%20smiling%20young%20asian%20woman%20volunteer%20wearing%20casual%20tshirt%20looking%20happy%20and%20fulfilled%20against%20soft%20neutral%20background%20representing%20community%20service%20dedication%20and%20positive%20impact%20with%20natural%20lighting%20and%20genuine%20expression&width=200&height=200&seq=voltest001&orientation=squarish"
                    alt="Volunteer"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="font-semibold text-charcoal text-lg">Lisa Chen</div>
                  <div className="text-gray-600 text-sm">Volunteer since 2022</div>
                  <div className="flex text-coral mt-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                </div>
              </div>
              <blockquote className="font-serif text-xl text-charcoal italic leading-relaxed">
                "Volunteering with 1 Heart has been the most rewarding experience. I've learned so much while helping others, and the community we've built is truly special."
              </blockquote>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}